import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OutgoingCallStatuses, ParticipantState } from '../types';
import { IncomingPostMessage, SyncMediaDevicePayload } from './types';

interface OutgoingCall {
    status: OutgoingCallStatuses;
    callee: Maybe<ParticipantState>;
}

type MessengerState = {
    outgoingCall: OutgoingCall;
};

const initialState: MessengerState = {
    outgoingCall: {
        status: OutgoingCallStatuses.RINGING,
        callee: undefined,
    },
};

const messengerSlice = createSlice({
    name: 'messenger',
    initialState,
    reducers: {
        setOutgoingCallStatus(state, action: PayloadAction<OutgoingCallStatuses>) {
            state.outgoingCall.status = action.payload;
        },
        setOutgoingCallCallee(state, action: PayloadAction<Maybe<ParticipantState>>) {
            state.outgoingCall.callee = action.payload;
        },
        resetMessengerState() {
            return initialState;
        },
    },
});
export const syncMediaDeviceAction = createAction<SyncMediaDevicePayload>('conference/messenger/syncMediaDeviceAction');
export const acceptCallAction = createAction('conference/messenger/acceptCallAction');
export const screenRecordingAction = createAction<IncomingPostMessage>('conference/messenger/screenRecordingAction');
export const { setOutgoingCallStatus, setOutgoingCallCallee, resetMessengerState } = messengerSlice.actions;

export const messengerReducer = messengerSlice.reducer;
